<script>

	let	blockOne = true
</script>
<section class="section dispatcher">
	<div class="container">
		<h2 class="h1 dispatcher__title b">For driver</h2>
		<div class="dispatcher__info">
			<h3 class="block-info__title h3">Drivers Get Real-Time Data with Our Truck Dispatch App</h3>
			<p class="block-info__text h5">Loder’s truck dispatch app makes it possible for drivers to stay informed while on the road.</p>
			<p class="block-info__text h5" class:block-info__text--hidden={blockOne}>Dispatchers and drivers can plan their future routes and organize their schedules conveniently with all the information easy to view in one place in the platform’s dashboard. </p>
			<p class="block-info__text h5" class:block-info__text--hidden={blockOne}>The drivers’ unique database organization is stored automatically unlike other dispatching apps that are not as customizable to the user’s experience.</p>
			<button class="block-info__description-open h5" on:click={() => {blockOne = !blockOne}}>
				{#if blockOne}
					Learn more <img src="../assets/icons/Arrow/Arrow_right.svg" alt="Learn more">
					{:else} 
					Close <img src="../assets/icons/Close_round.svg" alt="Close more">
				{/if}	
			</button>
		</div>
		<div class="block-info__img-container">
			<img src="../assets/img/dashboard.png" alt="dashboard" class="block-info__img block-info__img--1">
			<div class="block-info__more block-info__more--1">
				<img src="../assets/svg/fordriver.svg" alt="More info">
				<p class="block-info__more-text h5">This database includes all the information drivers need to make their runs, including pick-up time and location, cargo load weight, mileage, destination, offer rate, delivery location, and contact information. </p>
			</div>
			<div class="block-info__more block-info__more--2">
				<img src="../assets/svg/fordriver.svg" alt="More info">
				<p class="block-info__more-text h5">This dispatch platform is easy to use and manipulate, so drivers can take control of their information and organize their loads and routes as they desire.</p>
			</div>
			<div class="block-info__more block-info__more--3 block-info__more--reverse">
				<img src="../assets/svg/fordriver.svg" alt="More info">
				<p class="block-info__more-text block-info__more-text--3 h5">Drivers and dispatchers can also check the broker company, their rating, and many other factors before accepting a job in order to ensure a positive transportation experience.</p>
			</div>
		</div>
	</div>
</section>

<style>
	.section {
		padding:150px 0 150px ;
		background: var(--system-background-secondary);
	}
	.container {
		max-width: 1320px;
		width: 100%;
		margin: 0 auto;
		padding: 0px 10px;
		box-sizing: border-box;
	}
	.dispatcher__title {
		color: #2196F3;
		margin: 0;
		display: flex;
		align-items: center;
		margin-left: 52px;
		position: relative;
	}
	.dispatcher__title::after {
		content: '';
		display: block;
		position: absolute;
		left: 20px;
		bottom: -340px;
		height: 540px;
		border-left: 1px dashed #2196F3;
	}
	.dispatcher__title::before {
		content: '';
		display: block;
		width: 40px;
		height: 40px;
		border-radius: 10px;
		margin-right: 20px;
		background-color: #2196F3;
	}
	.block-info__title {
		position: relative;
		display: flex;
		align-items: flex-start;
		gap: 56px;
		max-width: 500px;
		margin: 0;
		color: var(--color-primary-500);
	}
	.block-info__title::before {
		content: '';
		display: block;
		width: 34px;
		height: 34px;
		min-width: 34px;
		min-height: 34px;
		background: var(--system-background-tertiary);
		border-radius: 50%;
	}
	.block-info__title::after {
		content: '';
		display: block;
		width: 34px;
		height: 34px;
		min-width: 34px;
		min-height: 34px;
		border: 5px solid var(--color-primary-500);
		border-radius: 50%;
		position: absolute;
		left: 12px;
		box-sizing: border-box;
	}
	.block-info__text {
		margin: 35px 0 20px 92px;
		max-width: 420px;
		color: var(--text-color-secondary);
	}
	.block-info__text + .block-info__text {
		margin: 0px 0px 20px 92px;
	}
	.block-info__text--hidden {
		display: none;
	}
	.block-info__description-open {
		display: flex;
		align-items: center;
		justify-content: center;
		gap: 10px;
		border: 0;
		background: transparent;
		color: var(--color-primary-300);
		outline: none;
		padding: 0;
		margin: 15px 0 0 92px;
	}
	.dispatcher__info {
		margin: 70px 0 70px 100px;
	}
	.block-info__img-container {
		position: relative;
		width: 100%;
	}
	.block-info__img {
		width: 100%;
		display: block;
	}
	.block-info__img-container::before {
		content: '';
		display: block;
		position: absolute;
		left: 72px;
		bottom: -150px;
		height: 158px;
		border-left: 1px dashed #2196F3;
	}
	.block-info__more {
		position: absolute;
	}
	.block-info__more--1 {
		top: 174px;
		left: 155px;
		z-index: 2;
	}
	.block-info__more--2 {
		top: 120px;
		left: 480px;
	}
	.block-info__more--3 {
		top: 460px;
		right: 270px;
		z-index: 3;
	}
	
	.block-info__more img {
		transition: .3s ease;
	}
	.block-info__more img:hover  {
		transform: rotate(45deg);
	}
	.block-info__more-text { 
		margin: 20px 0px 0px -40px;
		padding: 40px 40px 32px;
		border: 1px solid var(--system-background-tertiary);
		background-color: var(--system-background-primary);
		max-width: 545px;
		border-radius: 10px;
		color: var(--color-primary-500);
		opacity: 0;
		transition: .3s ease;
		position: relative;
		pointer-events: none;
	}
	.block-info__more-text::before { 
		content: '';
		position: absolute;
		width: 16px;
		height: 16px;
		top: -8px;
		left: 40px;
		transform: rotate(45deg);
		background-color: var(--system-background-primary);
		border-top: 1px solid var(--system-background-tertiary);
		border-left: 1px solid var(--system-background-tertiary);
	}
	.block-info__more-text--3::before { 
		left: auto;
		right: 40px;
	}
	.block-info__more img:hover + .block-info__more-text{
		opacity: 1;
	}
	.block-info__more--reverse {
		display: flex;
		flex-direction: column;
		align-items: flex-end;
	}
	.block-info__more--reverse .block-info__more-text {
		margin: 20px -40px 0px 0px;
	}
	.block-info__more--reverse .block-info__more-text::before {
		right: 40px
	}

	@media(max-width: 1200px) {
		.container {
			max-width: 1080px;
		}
		.section {
			padding: 120px 0 120px;
		}
		.dispatcher__title {
			font-size: 32px;
			line-height: 40px;
		}
		.block-info__title {
			font-size: 24px;
			line-height: 30px;
			gap: 50px;
		}
		.block-info__text {
			font-size: 16px;
			line-height: 20px;
			margin-left: 86px;
			margin-top: 25px;
		}
		.block-info__text + .block-info__text {
			margin: 0px 0px 20px 86px;
		}
		.block-info__description-open {
			margin-left: 86px;
			margin-top: 5px;
		}
		.block-info__more-text {
			font-size: 16px;
			line-height: 20px;
			padding: 25px;
			
		}
		.dispatcher__title::after {
			content: '';
			display: block;
			position: absolute;
			left: 20px;
			bottom: -310px;
			height: 470px;
			border-left: 1px dashed #2196F3;
		}
	}
	
	@media(max-width: 960px) {
		.container {
			max-width: 755px;
		}
		.block-info__more-text {
			max-width: 403px;
		}
		.block-info__more--1 {
			top: 72px;
			left: 73px;
		}
		.block-info__more--2 {
			top: 55px;
			left: 240px;
		}
		.block-info__more--3 {
			top: 200px;
			right: 122px;
		}
		.dispatcher__title::after {
			content: '';
			display: block;
			position: absolute;
			left: 20px;
			bottom: -300px;
			height: 440px;
			border-left: 1px dashed #2196F3;
		}
	}
	
	@media(max-width: 640px) {
		.dispatcher__title {
			font-size: 24px;
			line-height: 30px;
		}
		.container {
			max-width: 540px;
		}
		.section {
			padding: 100px 0 100px;
		}
		.block-info__title {
			font-size: 20px;
			line-height: 25px;
		}
		.block-info__text {
			font-size: 14px;
			line-height: 17px;
		}
		.block-info__description-open {
			font-size: 20px;
			line-height: 25px;	
		}
		.block-info__img-container {
			margin-bottom: -50px;
			width: 100%;
		}
		.block-info__img {
			width: 751px;
		}
		.block-info__more-text {
			max-width: 354px;
		}
		.block-info__more--1 {
			top: 90px;
			left: 90px;
		}
		.block-info__more--2 {
			top: 60px;
			left: 290px;
		}
		.block-info__more--3 {
			top: 255px;
			right: 50px;
		}
	}

	@media(max-width: 480px) {
		.container {
			max-width: 360px;
		}
		.dispatcher__title {
			margin-left: 10px;
		}
		.dispatcher__title::after {
			left: 14px;
			height: 410px;
			bottom: -310px;
		}
		.dispatcher__title::before {
			width: 25px;
			height: 25px;
			border-radius: 5px;
			margin-right: 20px;
		}
		.section {
			padding: 70px 0 70px ;
		}
		.block-info__description-open {
			margin-left: 0;
		}
		.block-info__text {
			margin-left: 0;
		}
		.block-info__text + .block-info__text {
			margin-left: 0;
		}
		.block-info__img-container {
			margin-bottom: -20px;
		}
		.block-info__img-container::before {
			left: 24px;
			bottom: -50px;
			height: 50px;
		}
		.block-info__title::after, .block-info__title::before {
			display: none;
		}
		.block-info__more-text {
			max-width: 267px;
			font-size: 14px;
			line-height: 17px;
		}
		.block-info__more--2 {
			display: flex;
			flex-direction: column;
			align-items: flex-end;
			left: auto;
			right: 20px;
		}
		.block-info__more--3 {
			right: 0;
			top: 275px;
		}
		.block-info__more--2 .block-info__more-text{
			margin: 20px -40px 0px 0px;
			width: 267px;
		}
		.block-info__more--2 .block-info__more-text::before{
			left: auto;
			right: 40px;
		}
	}
</style>